import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Austin",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Austin Minnesota southern Minnesota city along Interstate 90, Hormel Foods headquarters visible in the downtown skyline, commercial and industrial district with moderate traffic, flat agricultural landscape with cornfields visible on the edge of town, clear summer day with blue sky, professional aerial photography with clean composition, no readable signs or text",
  heroImageSeq: "austin-mn-hero-2026",
  heroDescription:
    "Business trip across the border with three weeks notice? Family cruise to Mexico with six weeks to spare? Heritage visit to Ireland or Norway planned? We help Austin residents — from Hormel Foods and area manufacturing professionals to Mower County families and the agricultural community — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "43.6681; -92.9744",
  geoPlacename: "Austin, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/austin-mn/",
  localAreaTitle: "Serving Austin & Southeast Minnesota",
  localAreaText: [
    "Austin, Minnesota is the county seat of Mower County and the anchor city of southeast Minnesota, located along the I-90 corridor near the Iowa border. The city is nationally recognized as the headquarters of Hormel Foods, one of the largest food companies in the world and a major local employer. The Hormel Foods plant and corporate offices provide significant employment for Austin and the surrounding region, and the company's history is preserved at the Spam Museum in downtown Austin.",
    "The city's location along Interstate 90 provides direct east-west access to Rochester, Albert Lea, and La Crosse, while I-35 connects south to the Twin Cities and north to Owatonna and Mankato. Austin is just 45 miles north of Rochester and the Mayo Clinic, making it a key part of the regional healthcare corridor. Many Austin residents travel to Rochester for specialized medical care and international medical referrals.",
    "Austin's economy is rooted in food processing, manufacturing, healthcare, and agriculture. The surrounding Mower County farmland is productive agricultural land, and the community maintains a strong connection to rural Minnesota. The city is also home to Riverland Community College, serving as a higher education hub for southeast Minnesota.",
    "The community's diverse population includes Hispanic and Latino communities, Southeast Asian communities, and long-established Scandinavian families. This diversity creates a rich cultural fabric where international travel is common — family visits to Mexico, heritage trips to Europe, and business travel for Hormel Foods and area manufacturers. The demand for expedited passport services in Austin reflects this community's global connections.",
  ],
  nearbyCities: [
    { name: "Austin", zips: "55912" },
    { name: "Albert Lea", zips: "56007" },
    { name: "Owatonna", zips: "55060" },
    { name: "Rochester", zips: "55901, 55902" },
    { name: "Northwood", zips: "50459" },
    { name: "Adams", zips: "55909" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Austin home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Austin area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Austin & Southeast Minnesota",
  serviceAreaDescription: "Serving Mower County and southeast Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Austin, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through an Austin area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Austin residents get passports before a business trip to Mexico or Canada?",
      a: "Absolutely. Austin residents with cross-border business trips — especially Hormel Foods and area manufacturing professionals — are among our southeast Minnesota clients. We process expedited renewals and new applications with compressed timelines.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Austin?",
      a: "No — most Austin travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Austin. You can ship from FedEx or UPS locations nearby in Austin or Albert Lea.",
    },
    {
      q: "My family is visiting relatives in Mexico. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Start as soon as you confirm travel plans.",
    },
    {
      q: "What if I need a passport for a last-minute business trip?",
      a: "Corporate travelers from Austin can use our emergency 24-hour service if they have proof of imminent travel. We process urgent renewals for Hormel Foods and area manufacturing professionals regularly.",
    },
    {
      q: "Are there passport acceptance facilities near Austin?",
      a: "The Austin Post Office and Albert Lea Post Office both accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "Austin, MN",
      rating: 5,
      text: "I needed to visit family in Mexico for an emergency situation and my passport had expired. I had two weeks. Fast Passport Center processed my renewal in five business days. I was able to be with my family when they needed me most. I am so grateful for their service.",
      service: "Emergency Renewal",
    },
    {
      name: "James T.",
      location: "Austin, MN",
      rating: 5,
      text: "I work in manufacturing and received a conference assignment to Germany with three weeks notice. My passport was expired. Fast Passport Center processed my renewal in four business days. The team was professional and kept me informed every step of the way.",
      service: "Passport Renewal",
    },
    {
      name: "The Nguyen Family",
      location: "Austin, MN",
      rating: 5,
      text: "Our family planned a trip to Vietnam to visit relatives and discovered our youngest child's passport was expired. We had six weeks. Fast Passport Center processed the child passport in eight business days. The checklist they provided made the process simple. We made our trip and had a wonderful time.",
      service: "Child Passport",
    },
  ],
  nearbyLinks: [
    { name: "Rochester", href: "/cities/rochester-mn" },
    { name: "Owatonna", href: "/cities/owatonna" },
    { name: "Mankato", href: "/cities/mankato" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Duluth", href: "/cities/duluth-mn" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Austin",
  introDescription: "Fast passport processing for Austin and southeast Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Austin and southeast Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Austin Post Office",
      address: "500 4th Ave NE, Austin, MN 55912",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(507) 433-2901",
      notes: "Primary passport acceptance facility for Austin and Mower County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Albert Lea Post Office",
      address: "141 S Newton Ave, Albert Lea, MN 56007",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 373-2361",
      notes: "Serves Albert Lea and northwest Austin area. Full passport services.",
    },
    {
      name: "Owatonna Post Office",
      address: "300 W Broadway St, Owatonna, MN 55060",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 451-3730",
      notes: "Steele County seat facility. Full passport services available.",
    },
    {
      name: "Rochester Post Office",
      address: "314 1st Ave SW, Rochester, MN 55902",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 282-2031",
      notes: "Olmsted County. Full passport services. Convenient for south Austin residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Austin", address: "1400 8th Ave NW, Austin, MN 55912", hours: "Call for hours" },
    { name: "CVS Pharmacy — Austin", address: "1001 18th Ave NW, Austin, MN 55912", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Albert Lea", address: "1200 W Main St, Albert Lea, MN 56007", hours: "Call for hours" },
    { name: "CVS Pharmacy — Albert Lea", address: "820 S Broadway Ave, Albert Lea, MN 56007", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Rochester", address: "1811 2nd St SW, Rochester, MN 55902", hours: "Call for hours" },
    { name: "FedEx Office — Rochester", address: "Rochester commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Mower County DVS Office",
      address: "201 1st St NE, Austin, MN 55912",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Mower County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Freeborn County DVS — Albert Lea",
      address: "411 S Broadway Ave, Albert Lea, MN 56007",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Freeborn County DVS. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "About 45 miles from Austin — 45–50 minutes by car",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Primary airport for Austin residents. Direct flights to Chicago, Atlanta, Minneapolis, and other hubs. International connections available.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "RST Airport Website",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 110 miles from Austin — 1 hour 45 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international airport for Austin residents. Full international flight service. Access via I-90 and I-35.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Hormel Foods & Manufacturing Business Travel",
      subtitle: "Corporate and manufacturing professionals with international assignments",
      content:
        "Austin is the headquarters of Hormel Foods, one of the largest food companies in the world. Area professionals in manufacturing, food processing, and corporate roles regularly travel internationally for business development, conferences, training, and quality control. These assignments are often confirmed with 2–4 weeks notice.",
      tip: "Austin professionals should maintain current passport validity. International business assignments are frequently confirmed on short notice.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Southeast Minnesota Family Travel",
      subtitle: "Mower County families planning international vacations and heritage trips",
      content:
        "Austin and Mower County families plan international vacations regularly — Mexico visits to see relatives, Caribbean cruises, and European heritage trips. Many families are multi-generational with international connections, and travel is often planned around school schedules and holiday breaks.",
      tip: "Check every family member's passport at least 8 weeks before any international trip. Children's passports expire in 5 years.",
      icon: "ri-parent-line",
    },
    {
      title: "Scandinavian Heritage & European Travel",
      subtitle: "Austin's Scandinavian community maintains strong European connections",
      content:
        "Austin has a long-established Scandinavian heritage community with Norwegian and Swedish roots. Many families maintain connections to European relatives and plan heritage trips. Scandinavian cultural events and community organizations keep these connections alive.",
      tip: "European heritage trips are often planned 6+ months in advance. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-earth-line",
    },
    {
      title: "Cross-Border Mexico Travel",
      subtitle: "Family visits and cultural travel to Mexico from Austin's Latino community",
      content:
        "Austin's Latino and Hispanic community maintains strong connections to Mexico, with family visits and cultural travel being common. These trips are often planned for holidays, family events, and summer vacations. Emergency family visits require fast passport processing.",
      tip: "Family visits to Mexico are most common during Christmas, Easter, and summer. Check passport validity at least 8 weeks before planned travel.",
      icon: "ri-map-2-line",
    },
  ],
  destinations: [
    {
      name: "Mexico",
      context: "Family visits and cultural travel for Austin's Hispanic community, plus resort destinations",
      urgency: "Family visits are often planned for holidays — passport must be current",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises and all-inclusive resorts for Austin families, popular with Mower County travelers",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway & Sweden",
      context: "Heritage travel for Austin's Scandinavian community",
      urgency: "Summer Scandinavian travel is planned months in advance but passport issues arise last minute",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Business travel for Hormel Foods and area manufacturing professionals",
      urgency: "Business meetings and conferences have fixed schedules",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Cross-border travel from Austin to Manitoba and Ontario",
      urgency: "Driving to Canada requires current passport or passport card",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Vietnam",
      context: "Family visits for Austin's Southeast Asian community",
      urgency: "Family visits are often planned months ahead but require valid passports for all travelers",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "35%", label: "of Austin expedited requests are family travel to Mexico with culturally significant timing" },
    { stat: "3–4 Weeks", label: "most common advance notice when Austin business travelers discover passport issues" },
    { stat: "May–Aug", label: "peak travel season corresponding with summer vacation and family reunion travel" },
    { stat: "5–7 Days", label: "typical expedited processing time for Austin clients choosing our recommended option" },
  ],
};

export default function AustinMNPage() {
  return <CityPage data={data} />;
}